import Vue, { VNode } from "vue";
import { Prop, Component } from 'vue-property-decorator';
import { State, Action } from "vuex-class";

@Component
export default class NotificationStack extends Vue {

  @State(s => s.notifications.notificationStack) stack;

  render() {
    return (
      <div class="notification-stack">
        {this.stack.map(notification => (
          <Notification
            key={notification.uid}
            uid={notification.uid}
            duration={notification.duration}
            message={notification.message}
            class={notification.className}
            level={notification.level}
          />
          ))
        }
      </div>
    );
  }
}

@Component
class Notification extends Vue {

  @Action closeNotification;

  @Prop({type: Object, required: true}) readonly message!: string | VNode;
  @Prop({type: Number, required: true}) readonly duration!: number;
  @Prop({type: String, required: true}) readonly uid!: string;
  @Prop({type: String, required: false, default: "default"}) readonly level!: string;

  protected timeO: number;

  mounted() {
    this.timeO = setTimeout(() => {
      this.close();
    }, this.duration);
  }

  close() {
    clearTimeout(this.timeO);
    this.closeNotification(this.uid);
  }

  render() {
    return (
      <div class={`notification is-${this.level}`}>
        <button class="delete" onClick={() => this.close()}></button>
        <p>{this.message}</p>
      </div>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0716f2bd/index.tsx" });